module.exports = __webpack_public_path__ + "static/img/00421v.21b6d99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00421v.jpg
// module id = LApX
// module chunks = 1